module.exports = __webpack_public_path__ + "static/media/download.6fbf2757.pdf";